import { Link } from 'react-router-dom';
import { articles } from '@/mocks/clCommunityData';

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门文章
          </h2>
          <p className="text-sm text-foreground-500 mt-1">社区精选优质内容，不容错过</p>
        </div>
        <Link
          to="/category/tech-discussion"
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          查看更多
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {hotArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:-translate-y-0.5 transition-all duration-300"
          >
            <div className="relative h-44 md:h-48 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                title={`${article.title} - CL社区`}
              />
              {article.isPinned && (
                <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs font-medium px-2.5 py-1 rounded-full">
                  置顶
                </span>
              )}
              <span className="absolute top-3 right-3 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium px-2.5 py-1 rounded-full">
                {article.categoryName}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <img
                    src={article.author.avatar}
                    alt={article.author.name}
                    className="w-6 h-6 rounded-full object-cover"
                  />
                  <span className="text-xs text-foreground-600">{article.author.name}</span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {article.comments}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}